import { Link } from '@reach/router';
import styled, { css } from 'styled-components';

import { mediaWide, mediaXWide } from '@xing-com/layout-tokens';
import {
  scale210,
  scale050,
  spaceS,
  spaceXS,
  spaceXXL,
  xdlColorDisabledStrong,
  xdlColorTextInvert,
  xdlColorText,
  scale160,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const Container = styled.div`
  position: relative;
  margin-bottom: ${scale160};

  @media ${mediaWide} {
    margin-bottom: ${scale210};
  }
`;

export const LettersListContainer = styled.div`
  display: flex;
  overflow-x: scroll;
  margin: 0 ${spaceXXL};
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  @media ${mediaXWide} {
    justify-content: space-around;
    margin: 0;
  }
`;

export const LetterContainer = styled(Link)<{
  $isActive: boolean;
}>`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  padding: ${spaceXS} ${scale050};

  @media ${mediaXWide} {
    padding-left: ${spaceS};
    padding-right: ${spaceS};
  }

  &:hover,
  &:focus {
    text-decoration: none;
  }

  ${({ $isActive }) =>
    $isActive &&
    `
      &:before {
        content: '';
        width: 24px;
        height: 24px;
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: -1;
        background-color: ${xdlColorText};
        border-radius: 12px;
      }
    `};
`;

export const LetterText = styled(BodyCopy)<{
  $isActive: boolean;
}>`
  ${({ $isActive }) =>
    $isActive &&
    css`
      color: ${xdlColorTextInvert};
    `};
`;

const ArrowContainer = styled.div<{
  $isDisabled: boolean;
}>`
  display: flex;
  align-self: stretch;
  position: absolute;
  top: 0;
  width: 24px;
  height: 100%;
  cursor: pointer;

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    pointer-events: none;
    color: ${xdlColorDisabledStrong};
  `}

  @media ${mediaXWide} {
    display: none;
  }
`;

export const ArrowContainerLeft = styled(ArrowContainer)`
  left: 0;
`;

export const ArrowContainerRight = styled(ArrowContainer)`
  right: 0;
`;
